import React, { useState } from "react";
import {Button, Form, Container, Alert, Spinner, InputGroup, Card} from "react-bootstrap";
import {fetchAmazonReviewData} from "../../http/bookAPI";


const AmazonReviewParser = ({ onExtract, setCurrentStep }) => {
    const [inputUrl, setInputUrl] = useState("");
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    const fetchReviewData = async () => {
        if (!inputUrl.trim()) {
            setError("Please enter a valid Amazon review URL.");
            return;
        }

        setLoading(true);
        setError("");

        try {
            const data = await fetchAmazonReviewData(inputUrl);

            // Передаем данные в родительский компонент
            if (onExtract) {
                onExtract(data);
                setCurrentStep('STEP5')
            }
        } catch (e) {
            setError("Great, we got your link. We couldn’t check it automatically, but we will review it manually. Thank you. No need to send it again — we already have it.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <Card className="mt-0 p-3 shadow-sm rounded w-100">
            {(() => {
                // show notice for today + tomorrow + the day after tomorrow
                const start = new Date();
                start.setHours(0, 0, 0, 0);
                const end = new Date(start);
                end.setDate(end.getDate() + 2);
                end.setHours(23, 59, 59, 999);
                const now = new Date();
                const showNotice = now >= start && now <= end;

                if (showNotice) {
                    return (
                        <Alert variant="warning" className="mb-0">
                            Sorry—Amazon has changed how review data can be accessed on their site, and we’re working on a fix. We expect this to take about 24–72 hours. In the meantime, this option is temporarily unavailable, but don’t worry—we’ll verify your review manually. Thank you.
                        </Alert>
                    );
                }

                return (
                    <>
                        <Form>
                            <InputGroup className="mb-0 border-success">
                                <Form.Control
                                    type="text"
                                    placeholder="Paste Your Amazon review link here..."
                                    value={inputUrl}
                                    onChange={(e) => setInputUrl(e.target.value)}
                                    disabled={loading}
                                    className="border-success"
                                />
                                <Button
                                    variant="success"
                                    onClick={fetchReviewData}
                                    disabled={loading}
                                >
                                    {loading ? <Spinner animation="border" size="sm" /> : "Submit"}
                                </Button>
                            </InputGroup>
                        </Form>

                        {error && (
                            <Alert variant="danger" className="mt-3">
                                {error}
                            </Alert>
                        )}
                    </>
                );
            })()}
        </Card>
    );

};

export default AmazonReviewParser;
